import { Component, computed, inject, input, output } from '@angular/core';
import { PaywallService } from '../../services/paywall.service';

@Component({
  selector: 'yon-pw-paywall-card',
  imports: [],
  templateUrl: './paywall-card.component.html',
  styleUrl: './paywall-card.component.scss'
})
export class PaywallCardComponent {
  paywallService: PaywallService = inject(PaywallService);
  hidePrice = input(false);
  cardSelect = output<void>();

  billingPeriodString = computed(() => {
    switch (this.paywallService.selectedBillingPeriod().value) {
      case 0: return 'Per month';
      case 1: return 'Per quarter';
      case 2: return 'Per year';
    }

    return '';
  });

  selectCard(): void {
    this.cardSelect.emit();
  }

}
